var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadioactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6102 3.08816C6.58374 3.85576 2.32061 9.36342 3.08821 15.3899C3.85581 21.4163 9.36347 25.6794 15.3899 24.9118C21.4164 24.1442 25.6795 18.6366 24.9119 12.6101C24.1443 6.58369 18.6366 2.32055 12.6102 3.08816Z",
    fill: "url(#paint0_linear_20957_4901)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0007 26.8332C6.913 26.8332 1.16732 21.0875 1.16732 13.9998C1.16732 6.91218 6.913 1.1665 14.0007 1.1665C21.0883 1.1665 26.834 6.91218 26.834 13.9998C26.834 21.0875 21.0883 26.8332 14.0007 26.8332ZM14.0007 24.9998C7.92552 24.9998 3.00065 20.075 3.00065 13.9998C3.00065 7.9247 7.92552 2.99984 14.0007 2.99984C20.0758 2.99984 25.0007 7.9247 25.0007 13.9998C25.0007 20.075 20.0758 24.9998 14.0007 24.9998Z",
    fill: "url(#paint1_linear_20957_4901)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0869 15.8739C15.0744 15.8739 15.8749 15.0734 15.8749 14.0859C15.8749 13.0984 15.0744 12.2979 14.0869 12.2979C13.0994 12.2979 12.2988 13.0984 12.2988 14.0859C12.2988 15.0734 13.0994 15.8739 14.0869 15.8739Z",
    fill: "#91919D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6553 11.6363L9.59067 6.57568C9.59067 6.57568 5.1264 8.78263 5.14557 14.0854H11.2716C11.2716 14.0854 11.0958 12.608 12.6521 11.6394L12.6553 11.6363Z",
    fill: "#91919D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7091 16.3731L9.85742 21.5859C9.85742 21.5859 13.9095 24.2063 18.44 21.445L15.4725 16.2729C15.4725 16.2729 14.2934 17.1903 12.7091 16.3763V16.3731Z",
    fill: "#91919D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5166 11.6363L18.4353 6.57568C18.4353 6.57568 22.6869 8.7857 22.6687 14.0854H16.8314C16.8314 14.0854 16.9988 12.608 15.5166 11.6394V11.6363Z",
    fill: "#91919D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20957_4901",
    x1: 13.4166,
    y1: 14.5833,
    x2: 0.581998,
    y2: -0.0743454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#F5F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20957_4901",
    x1: 14.584,
    y1: 13.4165,
    x2: 2.68133,
    y2: -0.398316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#DCDCE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997865,
    stopColor: "#DCDCE4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioactive);
export default __webpack_public_path__ + "static/media/radioactive.6dc67a0a20ed3beeca0efb2878213469.svg";
export { ForwardRef as ReactComponent };